import { render, staticRenderFns } from "./commit_refs.vue?vue&type=template&id=c72b04d8"
import script from "./commit_refs.vue?vue&type=script&lang=js"
export * from "./commit_refs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports